import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";

export interface FavoriteProps {
  productToken: string | undefined;
  hide: boolean;
  bestImage: IImage | undefined;
  boardTokens: Array<string> | undefined;
  brandToken: string | undefined;

  // Tracking
  impressionId: string | undefined;
  promotedBy: Array<keyof typeof IProduct.PromotedType> | undefined;
}

export const productTileFavoritePropsILeanProductTileAdapter = (
  productTile: ILeanProductTile
): FavoriteProps => {
  return {
    productToken: productTile.product?.token,
    hide: !productTile.product,
    bestImage: productTile.best_image,
    boardTokens: productTile.product?.board_tokens,
    brandToken: productTile.product?.brand_token,
    impressionId: productTile.product?.impression_id,
    promotedBy: productTile.product?.promoted_by,
  };
};
